import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DarkModeOutlined from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlined from "@mui/icons-material/LightModeOutlined";
import { useColorScheme } from "@mui/material/styles";

export default function ColorModeToggle() {
  const { mode, systemMode, setMode } = useColorScheme();

  // `mode` is "system" until the user picks explicitly, so fall back to the
  // resolved system value to decide which icon to show.
  const resolved = mode === "system" ? systemMode : mode;
  const nextMode = resolved === "dark" ? "light" : "dark";
  const label = `Switch to ${nextMode} mode`;

  return (
    <Tooltip title={label}>
      <IconButton onClick={() => setMode(nextMode)} aria-label={label} size="small">
        {resolved === "dark" ? (
          <LightModeOutlined fontSize="small" />
        ) : (
          <DarkModeOutlined fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
}
